//
//
//
//

/**
 * Renders the children with `display: contents`
 */
var script = {
  name: 'Fragment'
};
export { script as default };